// cart-drawer.js 或 theme.js

class GiftCartManager {
  constructor() {
    this.THRESHOLD_499 = 59900; // 499美元(分)
    this.THRESHOLD_699 = 69900; // 699美元(分)
    this.GIFT_VARIANT_499 = '51764754841911'; // 第一个赠品变体ID
    this.GIFT_VARIANT_699 = '51431083999543'; // 第二个赠品变体ID
    this.MAX_QUANTITY_499 = 1; // 第一个赠品最大数量
    this.MAX_QUANTITY_699 = 1; // 第二个赠品最大数量
    
    this.init();
  }

  init() {
    // 监听购物车更新
    // document.addEventListener('cart:refresh', (event) => this.updateGiftDisplay(event.detail));
    // document.addEventListener('cart:refresh', (event) => {
    //   console.log(111);
      
    // });
    //  document.addEventListener('cart:item-added', (event) => {
    //   console.log(222);
    //       });
    document.addEventListener('cart-drawer:open', (event) => {
      // console.log(333);
      this.updateGiftDisplay();
      setTimeout(() => {
        this.initGiftCarouselSwipe()
      }, 1000);
      setTimeout(() => {
        this.initGiftCarouselSwipe()
      }, 2000);
    });
    // document.addEventListener('line-item:change:start', (event) =>{
    //   console.log(event,555);
    // });
    document.addEventListener('line-item:change:end', (event) =>{
      // console.log(event,444);
      // this.initGiftCarouselSwipe()
      // this.removeGiftsIfPresent();
      this.updateGiftDisplay(event.detail.cart);
    });
    // 绑定赠品添加按钮事件
    this.bindGiftAddButtons();

    // 初始化赠品轮播滑动功能
    this.initGiftCarouselSwipe();
    

    
    // 初始更新显示
    this.updateGiftDisplay();
  }
  
  bindGiftAddButtons() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('gift-product-add')) {
        event.stopImmediatePropagation(); // 阻止事件进一步传播
        const button = event.target;
        const variantId = button.getAttribute('data-variant-id');
        const maxQuantity = parseInt(button.getAttribute('data-max-quantity') || 1);
        
        this.handleGiftAdd(variantId, maxQuantity);
        button.disabled = true;
      }
    });
  }

  async updateGiftDisplay(cart = null) {
    if (!cart) {
      cart = await this.getCart();
    }
    // console.log('updateGiftDisplay - received cart:', cart);
    const cartTotal = this.calculateNonGiftTotal(cart);
    // console.log('updateGiftDisplay - non-gift cart total:', cartTotal);
    
    // 更新进度条
    // this.updateProgressBar(cartTotal);
    
    // 更新进度条文本
    // this.updateProgressText(cartTotal);
     let step = document.querySelector('.gift-progress-step.step2')
      const amount = parseFloat(step.getAttribute('data-amount')) * 100;
      // console.log('amount',amount);
      
    // 显示/隐藏赠品选项
    if (cartTotal > this.THRESHOLD_699) {
    } else if (cartTotal > amount) {
      this.removeGift699IfPresent(cart);
    } else {
      this.removeGiftsIfPresent(cart);
    }
    
    // 更新赠品按钮状态
    // this.updateGiftButtons(cart);

    this.initGiftCarouselSwipe();
      // setTimeout(() => {
      //   this.initGiftCarouselSwipe()
      // }, 2000);
  }

  updateProgressBar(cartTotal) {
    document.querySelectorAll('.gift-progress-step').forEach(step => {
      const amount = parseFloat(step.getAttribute('data-amount')) * 100;
      if (cartTotal >= amount) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
    this.updateCurrentTotalPosition(cartTotal);
  }

  updateCurrentTotalPosition(cartTotal) {
    const currentTotalElement = document.querySelector('.gift-progress-current-bar');
    const progressBar = document.querySelector('.gift-progress-bar');
    if (!currentTotalElement || !progressBar) return;

    const progressBarWidth = progressBar.offsetWidth;
    const maxThreshold = this.THRESHOLD_699; // Use the highest threshold for calculation

    let positionPercentage = (cartTotal / maxThreshold) * 100;
    // Clamp the position to be within the bounds of the progress bar
    positionPercentage = Math.max(0, Math.min(100, positionPercentage));
    // console.log('updateCurrentTotalPosition - positionPercentage:', positionPercentage);
    // Adjust for the width of the currentTotalElement itself to center it
    // This is a rough estimate, more precise centering might require element.offsetWidth
    const offset = (currentTotalElement.offsetWidth / progressBarWidth) * 50; // Adjust by half its width in percentage
    
    // currentTotalElement.style.width = `calc(${positionPercentage}% - ${offset}px)`;
    // currentTotalElement.style.width = `${positionPercentage}%`;
    if(positionPercentage==100){
      currentTotalElement.style.borderTopRightRadius = '13px';
      currentTotalElement.style.borderBottomRightRadius = '13px';
    }else{
      currentTotalElement.style.borderTopRightRadius = '0';
      currentTotalElement.style.borderBottomRightRadius = '0';
    }
    // currentTotalElement.style.display = 'block';
  }
  
  updateProgressText(cartTotal) {
    const progressText = document.querySelector('.gift-progress-text p');
    if (!progressText) return;
    
    if (cartTotal < this.THRESHOLD_499) {
      const remaining = ((this.THRESHOLD_499 - cartTotal) / 100).toFixed(2);
      progressText.textContent = `Add $${remaining} more and upgrade to FREE Silk Eye Mask!`;
    } else if (cartTotal < this.THRESHOLD_699) {
      const remaining = ((this.THRESHOLD_699 - cartTotal) / 100).toFixed(2);
      progressText.textContent = `Add $${remaining} more and upgrade to FREE Pillow Cover!`;
    } else {
      progressText.textContent = 'Congratulations! You\'ve unlocked your gifts!';
    }
  }

  calculateNonGiftTotal(cart) {
    let total = 0;
    cart.items.forEach(item => {
      // 排除赠品,只计算普通商品金额
      if (item.variant_id.toString() !== this.GIFT_VARIANT_499 && 
          item.variant_id.toString() !== this.GIFT_VARIANT_699) {
        total += item.final_line_price;
      }
    });
    return total;
  }
  
  
  updateGiftButtons(cart) {
    let gift499InCart = false;
    let gift699InCart = false;

    // console.log('updateGiftButtons - current cart:', cart);
    // 检查购物车中是否有赠品
    // for (const item of cart.items) {
    //   console.log('updateGiftButtons - checking item:', item.variant_id.toString());
    //   if (item.variant_id.toString() === this.GIFT_VARIANT_499) {
    //     gift499InCart = true;
    //   }
    //   if (item.variant_id.toString() === this.GIFT_VARIANT_699) {
    //     gift699InCart = true;
    //   }
    // }
    // console.log('updateGiftButtons - gift499InCart:', gift499InCart, 'gift699InCart:', gift699InCart);

    // 更新按钮状态
    const button499 = document.querySelector(`.gift-product-item[data-variant-id="${this.GIFT_VARIANT_499}"] .gift-product-action button`);
    const button699 = document.querySelector(`.gift-product-item[data-variant-id="${this.GIFT_VARIANT_699}"] .gift-product-action button`);

        button499.className = 'gift-product-added';
        button499.textContent = 'Added';
        button499.disabled = true;
        button699.className = 'gift-product-added';
        button699.textContent = 'Added';
        button699.disabled = true;
    
    if (button499) {
      if (gift499InCart) {
        button499.className = 'gift-product-added';
        button499.textContent = 'Added';
        button499.disabled = true;
        
      } else {
        button499.className = 'gift-product-add';
        button499.textContent = 'Add';
        button499.disabled = false;
        
      }
    }
    
    if (button699) {
      if (gift699InCart) {
        button699.className = 'gift-product-added';
        button699.textContent = 'Added';
        button699.disabled = true;
        
      } else {
        button699.className = 'gift-product-add';
        button699.textContent = 'Add';
        button699.disabled = false;
        
      }
    }
  }

  async handleGiftAdd(variantId, maxQuantity) {
      // console.log('handleGiftAdd called for variant:', variantId, 'with quantity:', maxQuantity);
      try {
      // 先移除其他赠品(实现二选一)
      await this.removeOtherGifts(variantId);

      // $360.addToCart({
      //   qty: maxQuantity,
      //   variantId: variantId,
      //   properties: {
      //     '_gift': 'true'  // 标记为赠品
      //   }
      // });
      
      // 添加选中的赠品
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: maxQuantity,
            // properties: {
            //   '_gift': 'true'  // 标记为赠品
            // }
          }]
        })
      });

      // console.log('Add gift response:', response);
      if (response.ok) {
        // 刷新购物车
        await this.refreshCart();
      } else {
        console.error('添加赠品失败');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async removeOtherGifts(keepVariantId) {
    const cart = await this.getCart();
    const updates = {};
    let needsUpdate = false;
    
    for (const item of cart.items) {
      if ((item.variant_id.toString() === this.GIFT_VARIANT_499 || 
           item.variant_id.toString() === this.GIFT_VARIANT_699) && 
           item.variant_id.toString() !== keepVariantId) {
        updates[item.key] = 0;
        needsUpdate = true;
      }
    }
    
    if (needsUpdate) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }
  }
  
  async removeGift699IfPresent(cart) {
    const updates = {};
    let needsUpdate = false;
    
    for (const item of cart.items) {
      if (item.variant_id.toString() === this.GIFT_VARIANT_699) {
        updates[item.key] = 0;
        needsUpdate = true;
      }
    }
    
    if (needsUpdate) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      await this.refreshCart();
    }
  }

  async removeGiftsIfPresent(cart = null) {
    if (!cart) {
      cart = await this.getCart();
    }
    const updates = {};
    let needsUpdate = false;
    // for (let i = 0; i < cart.items.length; i++) {
    //   if(cart.items[i].variant_id.toString() === this.GIFT_VARIANT_499 || 
    //       cart.items[i].variant_id.toString() === this.GIFT_VARIANT_699) {
    //     // updates[cart.items[i].key] = 0;
    //     // needsUpdate = true;

    //     $360.updateItemQty({
    //       index: i+1,
    //       qty: 0,
    //       sections: ["cart-drawer", "cart-bubble"],
    //       sections_url: window.location.pathname
    //     });
        
    //   }
    // }
    
    for (const item of cart.items) {
      if (item.variant_id.toString() === this.GIFT_VARIANT_499 || 
          item.variant_id.toString() === this.GIFT_VARIANT_699) {
        updates[item.key] = 0;
        needsUpdate = true;
      }
    }
    // console.log(updates,'updates');
    
    if (needsUpdate) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      await this.refreshCart();
    }
  }

  async removeItem(lineKey) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });
  }

  async getCart() {
    const response = await fetch(`/cart.js?t=${new Date().getTime()}`);
    return await response.json();
  }

  async refreshCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: cart })
        );
      })
      .catch((error) => {
        console.error("Error refreshing cart:", error);
      });
  }

  initGiftCarouselSwipe() {
    // console.log(666);
    // 初始化 Swiper 轮播
    const giftSwiper = new Swiper('.gift-products-carousel', {
      slidesPerView: 'auto',
      spaceBetween: 5,
    });
    // console.log('Swiper initialized:', giftSwiper);
  }

}

// 初始化
// document.addEventListener('DOMContentLoaded', () => {
//   new GiftCartManager();
// });
